const ROLE_ADMIN = 4;

/** Alineado con backend: JWT cajero, id 5 o tipo "Cajero" en tipos_usuarios */
export function isCajeroUser(user) {
    if (!user) return false;
    if (user.cajero === true) return true;
    if (Number(user.role) === 5) return true;
    const name = String(user.role_name || '').trim().toLowerCase();
    return name === 'cajero';
}

/** Códigos VND e impresión: administrador (rol 4 o nombre con "administrador") o rol cuyo nombre incluye "jefe". */
export function canManageVendedorCodigos(user) {
    if (!user) return false;
    if (Number(user.role) === ROLE_ADMIN) return true;
    const rn = String(user.role_name || '').toLowerCase();
    return rn.includes('administrador') || rn.includes('jefe');
}

/**
 * RBAC helper. Usa la lista blanca user.permissions (poblada en /api/auth/login
 * desde rol_modulo_permisos) y devuelve booleano. Admin (rol 4) siempre `true`.
 *
 * @param {object} user - usuario del AuthContext (con `permissions: string[]`)
 * @param {string} code - código del permiso (ej: 'preventas_editar')
 * @returns {boolean}
 */
export function checkPermission(user, code) {
    if (!user) return false;
    if (Number(user.role) === ROLE_ADMIN) return true;
    const list = Array.isArray(user.permissions) ? user.permissions : [];
    return list.includes(code);
}
